export default {
  _106:
    'Tento uživatel nedokončil svou registraci kliknutím na odkaz v zaslané mailové zprávě. Nelze jej do aplikace přihlásit.',
  username: 'Uživatelské jméno',
  ecr_list: 'Seznam pokladen',
  wo_vat: 'bez DPH',
  settings: 'Nastavení',
  close: 'Zavřít',
  change_password: 'Změna hesla',
  old_password: 'Původní heslo',
  at_least_8_characters: 'Minimálně 8 znaků',
  new_password: 'Nové heslo',
  retype_password: 'Heslo znovu',
  proceed: 'Provést',
  edit_profile: 'Editace profilu',
  ic: 'IČ',
  name: 'Jméno',
  dic: 'DIČ',
  fname: 'Křestní jméno',
  surname: 'Příjmení',
  street: 'Ulice',
  city: 'Město',
  psc: 'PSČ',
  phone: 'Telefon',
  dddic: 'dddic',
  reset_password: 'Obnova hesla',
  forgotten_password: 'Zapomenuté heslo',
  email: 'Email',
  input_valid_email: 'Vložte platnou adresu emailu',
  back: 'Zpět',
  code: 'Ověřovací kód',
  ecode: 'Kód',
  message: 'Zpráva',
  Home: 'Domů',
  Services: 'Služby',
  Team: 'Team',
  erc_registration: 'Registrované pokladny',
  new_ecr: 'Nová pokladna',
  ecr_name: 'Pokladna popis',
  serial_no: 'ID modulu',
  cancel: 'Zrušit',
  save: 'Uložit',
  serial: 'ID modulu',
  fw: 'Verze firmware',
  model: 'Model',
  version: 'Modul verze',
  invoices_list: 'Přehled faktur',
  varsymbol: 'Variabilní symbol',
  subject: 'Předmět',
  totalvalue: 'Celkem',
  createdate: 'Vytvoření',
  taxdate: 'DÚZP',
  download: 'Stažení',
  password: 'Heslo',
  confirm_password: 'Heslo znovu',
  register: 'Registrace',
  select_service: 'Výběr licencí',
  select_licence: 'Vyber licenci',
  price: 'Cena',
  summary: 'Cena celkem',
  price_wo_vat: 'bez DPH',
  price_with_vat: 's DPH',
  vat_tariff: 'DPH',
  pay_order: 'Zaplatit objednávku',
  next: 'Další',
  sorry_not_found: 'Omlouváme se nenalezeno',
  try_this: 'Zkuste jít sem',
  home: 'Domů',
  logout: 'Odhlásit',
  cash_registers: 'Pokladny',
  services_mgmt: 'Licence',
  dealers_mgmt: 'Dealeři',
  profile: 'Profil',
  pwd_change: 'Změna hesla',
  invoices: 'Faktury',
  edit_ecr: 'Editace pokladny',
  about: 'O Nás',
  contact_us: 'Kontakty',
  stand_by: 'Strpení prosím',
  havent_account: 'Ještě nemáte účet',
  problem_password: 'Problém s heslem',
  register_self: 'Registrujte se',
  login: 'Přihlásit',
  this_email:
    'Váš email bude sloužit jako uživatelské jméno pro přístup k účtu',
  please_enter_pwd: 'Vložte heslo k vašemu účtu',
  welcome: 'Vítejte první krok byl úspěšně dokončen',
  thanks_for:
    'Byl vám zaslán e-mail. K dokončení registrace aktivujte na odkaz v e-mailu. Nyní budete přesměrováni na  přihlašovací stránku. Nebo použijte tlačítko',
  email_is_required: 'Email je vyžadován',
  email_must_be_valid: 'Email musí být platný',
  passwd_is_required: 'Heslo je vyžadováno',
  passwd_must_contains:
    'Heslo musí obsahovat alespoň 3  ze 4  (malé písmeno, velké písmeno, číslo, znak)',
  password_do_not_match: 'Hesla se neshodují',
  ico_is_required: 'IČO je vyžadováno',
  only_digits: 'Pouze číslice',
  create_a_password: 'Zadání hesla',
  account_created: 'Účet vytvořen',
  signup: 'Registrace uživatele',
  passwd_is_short: 'Heslo je příliš krátké min. 8 znaků',
  result: 'Výsledek',
  sorry_nothing:
    'Nic zde? Zdá se, že všechny pokladny mají tuto licenci zakoupenou',
  error_tile: 'Zpráva',
  input_data: 'Vložte údaje',
  house_number: 'Číslo popisné',
  buyed_licenses: 'Zakoupené licence',
  must_be_10_characters_long: 'Musí být min. 9  max.10 číslic',
  desc_is_required: 'Popis je vyžadován',
  code_is_required: 'Ověřovací kód je vyžadován',
  serial_is_required: 'ID modulu číslo je vyžadováno',
  must_be_8_characters_long: 'Musí být min. 5, max. 16 znaků',
  must_be_60_characters_long: 'Nesmí být delší než 60 znaků',
  code_numeric: 'Pouze numerické znaky',
  are_you_sure: 'Opravdu si přejete odebrat pokladnu?',
  field_is_required: 'Pole je vyžadováno',
  field_is_too_long: 'Hodnota v poli je příliš dlouhá',
  ecr_succ_added: 'Pokladna úspěsně přidána',
  ecr_succ_edited: 'Pokladna úspěsně aktualizována',
  payment: 'Platba',
  order_no: 'Objednávka číslo',
  amount: 'Částka',
  thanks: 'Děkujeme',
  sub_state: 'Oznámení',
  inconsistent_ico: 'Zadané IČO již existuje',
  chosse_one_option: 'Vyberte jednu z možností',
  cont_regist: 'Změnit IČO',
  end_registration: 'Dokončení registrace',
  reg_ok:
    'Vaše registrace byla dokončena v pořádku, budete přesměrováni na  přihlašovací stránku. Nebo použijte tlačítko',
  reg_fail: 'Registrace nedopadla dobře kontaktujte podpora_olp@novumglobal.eu',
  pwd_reset_email_send: 'Heslo změněno. Byl vám zaslán e-mail s novým heslem.',
  pwd_changed: 'Heslo bylo úspěšně změněno',
  profile_saved: 'Profil byl uložen',
  forbidden: 'Nemáte oprávnění',
  back_to_ecr: 'Zpět k pokladnám',
  choose_service: 'Výběr licence',
  select_ecrs: 'Výběr pokladen',
  send_code: 'Odeslat ověřovací kód e-mailem',
  send_code_tooltip:
    'Odešle ověrovací kód e mailem na adresu zadanou v pokladně EET nastavení',
  email_send_succ: 'E-mail byl úspěsně odeslán',
  terms: 'Souhlasím s obchodními ',
  conditions: 'podmínkami',
  products: 'Produkty',
  manual: 'Návod k použití',
  ic_msg: 'Vložte IČO',
  terms_cond: 'Obchodní podmínky',
  invoice: 'Faktura',
  delete_text: 'Varování',
  delete: 'Smazat',
  new_dealer: 'Nový dealer',
  not_selected: 'Není vybrána žadná pokladna',
  dealers: 'Dealeři',
  dealer_ok: 'Dealer byl úspěšně přidán',
  dealer_exist: 'Dealer s uvedeným IČO existuje',
  dealer_wait:
    'Dealer s uvedeným IČO existuje, čeká na dokončení registrace, nelze nastavit jako dealera',
  dealer_set_ok: 'Dealer byl uspěšně nastaven',
  edit_dealer: 'Editace dealera',
  search: 'Hledat',
  'your_search {search}': 'Hledaný výraz {search} nebyl nalezen',
  set_as_dealer: 'Nastavit jako dealera',
  dealer_conflict: 'Uživatel s tím to IČO existuje, nastavit jako dealera?',
  ProductId: 'ID produktu',
  ProductName: 'Název licence',
  IdentCode: 'Kód licence',
  ProductPeriod: 'Platnost',
  PriceWithoutVat: 'Cena bez DPH',
  VatTariff: 'Sazba DPH',
  dealer_set:
    'Byl nalezen partner se shodným IČO. Je možné jej nastavit jako dealera',
  mail_send: 'Faktura vám byla odeslána e-mailem',
  downld_tip: 'Kliknutím na ikonu začnete stahovat fakturu',
  regen_tip:
    'Kliknutím na ikonu regenerujete fakturu dle aktuálního nastavení profilu',
  regeneration: 'Akce',
  house_ref: 'Číslo orientační',
  vat_invalid_format: 'Neplatný formát DIČ',
  ares: 'Zapsat dle ARES'
}
